export const categories = [
  { slug: "80s-movies", name: "80年代电影", icon: "ri-film-line", description: "80年代经典电影回顾，重温那个纯真年代的光影记忆" },
  { slug: "90s-tv", name: "90年代电视剧", icon: "ri-tv-line", description: "90后童年必看的经典电视剧，每一部都是回忆杀" },
  { slug: "cartoon", name: "童年动画", icon: "ri-rocket-line", description: "放学后守在电视机前的动画片，满满都是回忆" },
  { slug: "hongkong", name: "港片经典", icon: "ri-vidicon-line", description: "香港电影黄金时代的经典作品，一代人的青春记忆" },
  { slug: "classic-rewatch", name: "经典重温", icon: "ri-heart-line", description: "百看不厌的经典老片，每次重温都有新感动" },
  { slug: "nostalgia-music", name: "影视金曲", icon: "ri-music-line", description: "那些年我们一起听过的影视主题曲和插曲" },
];

export const featuredMovies = [
  {
    id: 1,
    title: "大话西游之大圣娶亲",
    slug: "a-chinese-odyssey-part-two",
    year: 1995,
    category: "hongkong",
    director: "刘镇伟",
    cast: ["周星驰", "朱茵", "吴孟达", "莫文蔚"],
    rating: 9.2,
    imageUrl: "https://readdy.ai/api/search-image?query=A%20nostalgic%20warm-toned%20Chinese%20movie%20scene%20with%20classic%20film%20texture%2C%20golden%20hour%20lighting%2C%20romantic%20ancient%20Chinese%20palace%20atmosphere%2C%20soft%20sepia%20tone%2C%20cinematic%20composition%2C%20warm%20amber%20glow%2C%20retro%20film%20grain%20effect%2C%20dreamy%20nostalgic%20mood%2C%20no%20text%20overlay%2C%20clean%20background&width=800&height=600&seq=featured-movie-01&orientation=landscape",
    excerpt: "曾经有一份真诚的爱情放在我面前，我没有珍惜，等我失去的时候我才后悔莫及...",
    content: `《大话西游之大圣娶亲》是1995年上映的香港奇幻喜剧电影，由刘镇伟执导，周星驰、朱茵主演。这部电影虽然在当时票房表现平平，但随着时间的推移，它成为了华语电影史上最具影响力的作品之一。

## 剧情简介

至尊宝（周星驰 饰）为了救紫霞仙子（朱茵 饰），借助月光宝盒穿越时空，回到了五百年前。在那里，他遇到了还未成为孙悟空的前世，也遇到了让他心动不已的紫霞仙子。

紫霞仙子曾许下誓言：谁能拔出她的紫青宝剑，谁就是她的如意郎君。至尊宝无意中拔出了宝剑，从此与紫霞结下不解之缘。然而，命运弄人，至尊宝最终必须戴上紧箍咒，成为孙悟空，才能救回紫霞...

## 经典台词

> "曾经有一份真诚的爱情放在我面前，我没有珍惜，等我失去的时候我才后悔莫及，人世间最痛苦的事莫过于此。如果上天能够给我一个再来一次的机会，我会对那个女孩子说三个字：我爱你。如果非要在这份爱上加上一个期限，我希望是...一万年。"

> "我的意中人是个盖世英雄，有一天他会踩着七色的云彩来娶我，我猜中了前头，可是我猜不着这结局。"

## 为什么成为经典

这部电影之所以历久弥新，在于它将无厘头喜剧与深刻的情感内核完美结合。年少时看是喜剧，长大后看是悲剧，人到中年再看，才发现这是一部关于成长与放下的寓言。`,
  },
  {
    id: 2,
    title: "新白娘子传奇",
    slug: "the-legend-of-white-snake",
    year: 1992,
    category: "90s-tv",
    director: "夏祖辉",
    cast: ["赵雅芝", "叶童", "陈美琪"],
    rating: 9.5,
    imageUrl: "https://readdy.ai/api/search-image?query=A%20warm%20nostalgic%20classical%20Chinese%20drama%20scene%20with%20elegant%20ancient%20costumes%2C%20soft%20golden%20lighting%2C%20traditional%20Chinese%20architecture%20bridge%20and%20lake%2C%20gentle%20sepia%20tone%2C%20retro%20television%20drama%20aesthetic%2C%20romantic%20atmosphere%2C%20no%20text%2C%20clean%20composition&width=800&height=600&seq=featured-movie-02&orientation=landscape",
    excerpt: "千年等一回，等一回啊...白娘子和许仙的爱情故事，陪伴了无数90后的童年时光。",
    content: `《新白娘子传奇》是1992年由台湾电视公司出品的古装神话电视剧，由夏祖辉执导，赵雅芝、叶童、陈美琪主演。这部剧改编自中国四大民间传说之一的《白蛇传》，是华语电视剧史上不可逾越的经典。

## 剧情简介

白素贞（赵雅芝 饰）是一条修炼千年的白蛇精，为报恩来到人间寻找前世恩人许仙（叶童 饰）。两人在西湖断桥相遇，一见钟情，结为夫妻。然而法海和尚认为人妖不能相恋，百般阻挠，最终将白素贞镇压在雷峰塔下...

## 为什么让人念念不忘

1. **黄梅调唱腔**：剧中大量采用黄梅戏唱段，边演边唱的形式独树一帜，让整部剧充满了韵味
2. **赵雅芝的经典形象**：白衣飘飘的白娘子成为了几代人心中的女神
3. **感人至深的爱情**：跨越物种的爱情故事，探讨了爱、责任与牺牲的永恒主题

## 经典金句

> "十年修得同船渡，百年修得共枕眠"

> "西湖的水，我的泪，我情愿和你化作一团火焰"`,
  },
  {
    id: 3,
    title: "灌篮高手",
    slug: "slam-dunk",
    year: 1993,
    category: "cartoon",
    director: "西沢信孝",
    cast: ["草尾毅", "绿川光", "置鲇龙太郎"],
    rating: 9.7,
    imageUrl: "https://readdy.ai/api/search-image?query=Anime%20style%20basketball%20scene%20with%20warm%20nostalgic%20retro%20color%20palette%2C%20golden%20sunset%20gymnasium%20lighting%2C%201990s%20Japanese%20animation%20aesthetic%2C%20basketball%20court%20atmosphere%2C%20warm%20amber%20and%20orange%20tones%2C%20no%20text%2C%20clean%20composition%2C%20dreamy%20nostalgic%20vibe&width=800&height=600&seq=featured-movie-03&orientation=landscape",
    excerpt: "教练，我想打篮球！一句台词，让无数80后90后热血沸腾，这是青春的代名词。",
    content: `《灌篮高手》（SLAM DUNK）是日本漫画家井上雄彦创作的篮球题材漫画，1993年改编为电视动画。这部作品不仅在日本引发篮球热潮，在中国更是影响了整整一代人。

## 剧情简介

不良少年樱木花道为了追求心仪的女生赤木晴子，加入了湘北高中篮球部。从对篮球一无所知的新手，到逐渐爱上这项运动，樱木与队友流川枫、赤木刚宪、三井寿、宫城良田一起，朝着全国大赛的梦想奋进。

## 经典角色

- **樱木花道**：自称"天才"的红发少年，有着惊人的运动天赋
- **流川枫**：冷酷的天才球员，樱木的"宿敌"
- **三井寿**：曾经的MVP，浪子回头的三分射手
- **赤木刚宪**：湘北的支柱，"大猩猩"队长

## 经典台词

> "教练，我想打篮球！" —— 三井寿

> "直到最后一刻，都不能放弃希望。" —— 安西教练

> "因为我是天才！" —— 樱木花道`,
  },
];

export const articleList = [
  {
    id: 4,
    title: "还珠格格：那些年我们追过的格格和阿哥",
    slug: "princess-pearl",
    year: 1998,
    category: "90s-tv",
    imageUrl: "https://readdy.ai/api/search-image?query=Classical%20Chinese%20palace%20drama%20scene%20with%20warm%20nostalgic%20lighting%2C%20traditional%20costumes%2C%20royal%20garden%20setting%2C%20soft%20golden%20hour%20glow%2C%20retro%201990s%20TV%20drama%20aesthetic%2C%20sepia%20warm%20tones%2C%20no%20text%2C%20clean%20composition&width=800&height=600&seq=article-list-01&orientation=landscape",
    excerpt: "让我们红尘作伴活得潇潇洒洒，策马奔腾共享人世繁华...98年那个夏天，全中国都在看格格。",
    rating: 9.0,
  },
  {
    id: 5,
    title: "霸王别姬：不疯魔不成活的绝世经典",
    slug: "farewell-my-concubine",
    year: 1993,
    category: "80s-movies",
    imageUrl: "https://readdy.ai/api/search-image?query=Chinese%20Peking%20opera%20stage%20scene%20with%20dramatic%20lighting%2C%20traditional%20theater%20atmosphere%2C%20warm%20golden%20and%20red%20tones%2C%20elegant%20costume%20details%2C%20cinematic%20composition%2C%20nostalgic%20film%20texture%2C%20soft%20sepia%20glow%2C%20no%20text%2C%20clean%20background&width=800&height=600&seq=article-list-02&orientation=landscape",
    excerpt: "张国荣的巅峰之作，陈凯歌的封神之作，中国电影史上唯一获得金棕榈奖的作品。",
    rating: 9.6,
  },
  {
    id: 6,
    title: "西游记86版：永远的经典，无法超越的童年记忆",
    slug: "journey-to-the-west-86",
    year: 1986,
    category: "80s-movies",
    imageUrl: "https://readdy.ai/api/search-image?query=Classical%20Chinese%20mythological%20scene%20with%20warm%20nostalgic%20atmosphere%2C%20traditional%20ancient%20landscape%2C%20golden%20clouds%20and%20heavenly%20light%2C%201980s%20TV%20production%20aesthetic%2C%20sepia%20warm%20tones%2C%20dreamy%20composition%2C%20no%20text%2C%20clean%20background&width=800&height=600&seq=article-list-03&orientation=landscape",
    excerpt: "你挑着担，我牵着马...每当这个旋律响起，仿佛又回到了那个无忧无虑的暑假。",
    rating: 9.8,
  },
  {
    id: 7,
    title: "英雄本色：小马哥的风衣与墨镜，定义了那个年代的酷",
    slug: "a-better-tomorrow",
    year: 1986,
    category: "hongkong",
    imageUrl: "https://readdy.ai/api/search-image?query=Hong%20Kong%20action%20film%20scene%20with%20warm%20retro%20lighting%2C%201980s%20style%20trench%20coat%20silhouette%2C%20noir%20atmosphere%2C%20golden%20hour%20street%20scene%2C%20cinematic%20composition%2C%20sepia%20warm%20tones%2C%20no%20text%2C%20clean%20background&width=800&height=600&seq=article-list-04&orientation=landscape",
    excerpt: "周润发、狄龙、张国荣，吴宇森的暴力美学巅峰之作，港片的黄金时代就藏在这里。",
    rating: 9.3,
  },
  {
    id: 8,
    title: "天龙八部97版：乔峰、段誉、虚竹的江湖情仇",
    slug: "demi-gods-and-semi-devils-97",
    year: 1997,
    category: "90s-tv",
    imageUrl: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20martial%20arts%20scene%20with%20warm%20dramatic%20lighting%2C%20mountainous%20landscape%2C%20traditional%20warrior%20costumes%2C%20epic%20cinematic%20atmosphere%2C%20golden%20hour%20glow%2C%20nostalgic%201990s%20TV%20drama%20aesthetic%2C%20no%20text%2C%20clean%20composition&width=800&height=600&seq=article-list-05&orientation=landscape",
    excerpt: "黄日华版乔峰，自带BGM的男人，每次出场都让人热血沸腾。",
    rating: 9.4,
  },
  {
    id: 9,
    title: "大头儿子小头爸爸：陪伴两代人的童年动画",
    slug: "big-head-son",
    year: 1995,
    category: "cartoon",
    imageUrl: "https://readdy.ai/api/search-image?query=Warm%20family%20animation%20scene%20with%20cozy%20home%20atmosphere%2C%20soft%20warm%20lighting%2C%20Chinese%20cartoon%20aesthetic%2C%20happy%20family%20moment%2C%20nostalgic%201990s%20feel%2C%20sepia%20warm%20tones%2C%20no%20text%2C%20clean%20composition&width=800&height=600&seq=article-list-06&orientation=landscape",
    excerpt: "大手牵小手，走路不怕滑...这部动画片陪伴了无数80后、90后的童年。",
    rating: 8.8,
  },
  {
    id: 10,
    title: "肖申克的救赎：希望是好事，也许是世间最好的事",
    slug: "shawshank-redemption",
    year: 1994,
    category: "80s-movies",
    imageUrl: "https://readdy.ai/api/search-image?query=Cinematic%20prison%20scene%20with%20warm%20hopeful%20lighting%2C%20golden%20sunset%20rays%2C%20dramatic%20atmosphere%2C%20classic%20film%20texture%2C%20nostalgic%20sepia%20tones%2C%20emotional%20and%20inspiring%20composition%2C%20no%20text%2C%20clean%20background&width=800&height=600&seq=article-list-07&orientation=landscape",
    excerpt: "IMDb排名第一的神作，关于希望、自由和友谊的永恒故事。",
    rating: 9.7,
  },
  {
    id: 11,
    title: "无间道：出来混，迟早要还的",
    slug: "infernal-affairs",
    year: 2002,
    category: "hongkong",
    imageUrl: "https://readdy.ai/api/search-image?query=Hong%20Kong%20crime%20film%20scene%20with%20tense%20atmosphere%2C%20rooftop%20confrontation%2C%20warm%20golden%20cityscape%20background%2C%20noir%20cinematic%20style%2C%20sepia%20warm%20tones%2C%20no%20text%2C%20clean%20composition&width=800&height=600&seq=article-list-08&orientation=landscape",
    excerpt: "刘德华和梁朝伟的天台对决，港产警匪片的巅峰之作。",
    rating: 9.3,
  },
];

export const testimonials = [
  {
    name: "小李",
    avatar: "李",
    comment: "8090电影网简直就是我的青春回忆录！每次打开都能找到小时候看过的电影电视剧，满满的感动。",
    year: "80后",
  },
  {
    name: "阿花",
    avatar: "花",
    comment: "在这里找到了好多小时候看的动画片，灌篮高手、美少女战士...带娃一起看，他也很喜欢！",
    year: "90后",
  },
  {
    name: "老王",
    avatar: "王",
    comment: "《大话西游》看了十几遍了，每次看到紫霞仙子的镜头还是会哭。感谢这个网站，保存了我们的回忆。",
    year: "80后",
  },
  {
    name: "小美",
    avatar: "美",
    comment: "港片迷的福音！英雄本色、倩女幽魂、古惑仔...这里几乎都有介绍，而且信息很全。",
    year: "90后",
  },
  {
    name: "大刘",
    avatar: "刘",
    comment: "周星驰的电影反复看了不知道多少遍，每次心情不好的时候就来看看，瞬间治愈。",
    year: "80后",
  },
  {
    name: "小陈",
    avatar: "陈",
    comment: "终于找到一个专门做怀旧影视的网站了！页面设计也很用心，满满的复古情怀。",
    year: "90后",
  },
];

export const faqs = [
  {
    q: "8090电影网提供在线观看吗？",
    a: "8090电影网是一个怀旧影视资料库和信息平台，主要提供经典电影和电视剧的详细介绍、经典台词、幕后故事等内容。我们目前不直接提供视频播放服务，但会为每部作品提供详细的影视资料和观看渠道建议。",
  },
  {
    q: "网站收录了哪些年代的影视作品？",
    a: "我们主要收录1980年代至2000年代初期的经典影视作品，包括80年代经典电影、90年代热门电视剧、经典动画片、香港电影黄金时代作品以及相关的影视金曲。我们的目标是保存那个黄金年代的光影记忆。",
  },
  {
    q: "如何找到我想看的影视作品？",
    a: "你可以通过首页的分类导航浏览不同类别的作品，包括80年代电影、90年代电视剧、童年动画、港片经典等。也可以使用页面顶部的搜索功能来快速找到你想看的内容。",
  },
  {
    q: "网站内容会定期更新吗？",
    a: "会的！我们的团队会定期更新新的影视作品介绍和深度文章，同时也会根据用户的反馈不断丰富已有内容。如果你有想看的作品，欢迎通过联系我们页面给我们留言。",
  },
  {
    q: "可以推荐影视作品给朋友吗？",
    a: "当然可以！每篇文章都有分享功能，你可以方便地把喜欢的影视作品推荐给同样热爱怀旧影视的朋友，一起重温那些美好的回忆。",
  },
];

export const allArticles = [...featuredMovies, ...articleList];